/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { JoinCell, PlatformReceivedCell, PlatformStatusCell, RailsDecisionCell, WhatChangedCell, WhenCell } from './PushHistoryCells';
import { confirmedAfterReplayRow, linkedRow, platformOnlyRow, replayCappedRow, suppressedRow, unconfirmedRow } from './fixtures';
const ZONE = 'America/New_York';
function CellsRow({ row }) {
    return (React.createElement("div", { className: "push-history", style: { display: 'flex', gap: '2rem', alignItems: 'center' } },
        React.createElement(WhenCell, { row: row, timeZone: ZONE, expanded: false }),
        React.createElement(RailsDecisionCell, { row: row }),
        React.createElement(WhatChangedCell, { row: row, timeZone: ZONE }),
        React.createElement(JoinCell, { row: row }),
        React.createElement(PlatformStatusCell, { row: row, platformUnavailable: false }),
        React.createElement(PlatformReceivedCell, { row: row, timeZone: ZONE })));
}
const meta = {
    title: 'Features/Settings/Technicians/PushHistory/PushHistoryCells',
    component: CellsRow,
    parameters: { layout: 'padded' }
};
export default meta;
export const Linked = { args: { row: linkedRow } };
export const HeldBack = { args: { row: suppressedRow } };
export const PlatformOnlyFailed = { args: { row: platformOnlyRow } };
export const Pending = {
    args: { row: Object.assign(Object.assign({}, suppressedRow), { railsOutcome: 'pending', suppressedReason: null, sendsAt: '2099-01-01T12:00:00Z' }) }
};
export const NotConfirmedReplayed = { args: { row: unconfirmedRow } };
export const ConfirmedAfterReplay = { args: { row: confirmedAfterReplayRow } };
export const ReplayCapped = { args: { row: replayCappedRow } };
